import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const BannerContainer = styled.div`
    margin: 16px 24px 0;

    .sharing-modal-banner {
        padding: 24px;
        background-color: ${colorsPalettes.sky[100]};

        > div {
            align-items: initial;

            > div:last-of-type {
                margin: 0 24px 0 16px;
            }
        }

        .icon-users {
            svg {
                width: 24px;
            }
        }

        p {
            &:first-of-type {
                margin-bottom: 4px;
                ${setFontVariant("subtitle1", colorsPalettes.indigo[300])};
            }

            &:last-of-type {
                ${setFontVariant("body2", colorsPalettes.indigo[300])};
            }
        }

        .Button {
            background-color: ${colorsPalettes.indigo[300]};
        }
    }
`;
